const GLOBAL_ERROR_MSG =
    'Uh-oh! I’m currently experiencing some technical difficulties cannot assist you right now. Please try again later.';
const ERROR_MESSAGES: Record<string, string> = {
    NOT_TAAP_NOT_INTERNET: GLOBAL_ERROR_MSG,
    NOT_TAAP_YES_INTERNET_YES_GOOGLE: GLOBAL_ERROR_MSG,
    NOT_TAAP_YES_INTERNET_NO_GOOGLE: GLOBAL_ERROR_MSG,
    GENERIC_ERROR: GLOBAL_ERROR_MSG,
};

export default ERROR_MESSAGES;
